import { render, staticRenderFns } from "./FamilyDataMarketingCampaigns.vue?vue&type=template&id=7c0108e2&scoped=true&"
import script from "./FamilyDataMarketingCampaigns.vue?vue&type=script&lang=ts&"
export * from "./FamilyDataMarketingCampaigns.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyDataMarketingCampaigns.vue?vue&type=style&index=0&id=7c0108e2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0108e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VCardTitle,VCol,VContainer,VRow,VSpacer})
